import { Typography } from "@mui/material";
import ContactUsButton from "app/frontend/components/buttons/ContactUsButton";
import Panel from "app/frontend/components/Panel";

const Consult = () => {
    return <>Talk to an Advisor Early to Confirm Hosting Capacity</>;
};

export default function ConsultAnAdvisor({ text }: { text?: string }) {
    return (
        <Panel sx={{ textAlign: "center" }}>
            <Typography variant="h1" component={"h2"} sx={{ textTransform: "capitalize" }}>
                {text || <Consult />}
            </Typography>
            <ContactUsButton isIcon={false} />
        </Panel>
    );
}
